import { capitalCase, sentenceCase } from 'change-case'
import { useState, useEffect, useRef } from 'react'
import { useSnackbar } from 'notistack';
// material
import {
  Container,
  Tab,
  Box,
  Tabs,
  Stack,
  Typography,
  MenuItem,
  TextField,
  Card,
  Grid,
  Divider,
  CircularProgress,
  AvatarGroup,
  Tooltip,
  Avatar,
  IconButton,
  Skeleton,
} from '@material-ui/core'
import { useTheme, experimentalStyled as styled } from '@material-ui/core/styles'
// components
import Posts from '../../components/projects/viewProjects/ViewTasks/Posts'
import Attachments from '../../components/projects/viewProjects/ViewTasks/Attachments'
import SubTasks from '../../components/projects/viewProjects/ViewTasks/SubTasks'
import Activities from '../../components/projects/viewProjects/ViewTasks/Activities'
import { useLocation, useNavigate, useParams } from 'react-router'
import axios from 'axios'
import { currentFacilityId, REST_API_END_POINT, BASE_URL_QR } from 'src/constants/Defaultvalues'
import { UserMoreMenu } from 'src/components/_dashboard/user/list'
import AddTask from 'src/components/projects/AddTask'
import ConfirmationPopup from 'src/components/confirmationPopup';
import { PATH_DASHBOARD } from 'src/routes/paths';
import {Button} from '@material-ui/core';
import { Info, KeyboardBackspaceOutlined, Login, Logout, TryOutlined, PictureAsPdf, Visibility, QrCode2 } from '@material-ui/icons';
import { Link as RouterLink } from 'react-router-dom'
import { truncate } from 'lodash';
import LoadingScreen from 'src/components/LoadingScreen';
import Label from 'src/components/Label';
import { DialogAnimate } from 'src/components/animate';
import { Icon } from '@iconify/react';
import filePdfIcon from '@iconify/icons-mdi/file-pdf';
import ViewProductFormulaModal from 'src/components/ViewProductFormulaModal';
import QRCode from 'react-qr-code';
import ReactToPrint from 'react-to-print';
import { PrintOutlined } from '@material-ui/icons';


// ----------------------------------------------------------------------

let option = [
  { id: 1, color:'primary', value: 'New' },
  { id: 2, color:'info', value: 'In Progress' },
  { id: 3, color:'success', value: 'Completed' },
  { id: 4, color:'warning', value: 'In Testing' },
  { id: 5, color:'error', value: 'Canceled' },
  { id: 6, color:'success', value: 'Approved by Dev team' },
  { id: 7, color:'success', value: 'Approved by the client' },
  { id: 8, color:'primary', value: 'Reopen' },
]
const colors = [
  '#c9302c',
  '#5bc0de',
  '#008000',
  '#5cb85c',
  '#f0ad4e',
  '#c9302c',
  '#5cb85c',
  '#5cb85c',
  '#5bc0de',
]

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
})

export default function ViewTask({popupOn,postId,projectsId,taskCurrentTab,taskDetails,handleBackToAlljobs,onDataChange,requestId}) {
 
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate()
  const { id:paramsId, projectId:paramsProjectId } = useParams();
  const id = popupOn? postId:paramsId;
  console.log('popupOnpopupOnpopupOn', popupOn)
  const projectId = popupOn? projectsId:paramsProjectId;

  const theme = useTheme()
  const ref = useRef(null)
  const designs =useLocation().state?.design || null
   const currentTab=popupOn ? taskCurrentTab: useLocation().state?.currentTab
   const details=popupOn ?taskDetails: useLocation().state?.details
   console.log('detailssssssssssss', details)
  console.log("##############CurrentTab",useLocation());
  const logo =
    'https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg'
  const [secTab, setSecTab] = useState('SUBTASKS')
  const [value, setValue] = useState({ id: 1, value: 'New' })
  const [data,setData] = useState(null)
  const [subTasks,setSubTasks] = useState(null)
  const [projectMembers,setProjectMembers] = useState(null)
  const [isEdit,setIsEdit] = useState(false)
  const [isDelete,setIsDelete] = useState(false)
  const [fetchData,setFetchData] = useState(false)
  const [projectPosts,setProjectPosts] = useState([])
  const [refresh,setRefresh] = useState(false)
  const [options,setOptions]= useState(option)
  const [skills,setSkills] = useState([])
  const [taskAttachments,setTaskAttachments] = useState([])
  const user = JSON.parse(window.localStorage.getItem('user'))
   const explodedPermissions = user?.exploded_permissions
  const hasJobPermission = explodedPermissions?.some((permission) => ['Update Job Status'].includes(permission)) ? true : false
  const hasViewAsAdminPermission = explodedPermissions?.some((permission) =>
    ['View as admin', 'View Workflow as Admin'].includes(permission)
  )
  const userId = user?.user_id
  const isClient = user?.isClient;
  let userType = isClient ? 3 : user.user_type
  
  // PDF modal state
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(true);
  const [useOfficeViewer, setUseOfficeViewer] = useState(true);
  const [openViewProductFormulaModal, setOpenViewProductFormulaModal] = useState(false);
  const [isMirrored, setIsMirrored] = useState(false);
  const [openQRModal, setOpenQRModal] = useState(false);
  const qrCodeRef = useRef(null);
  // Helper function to check if URL is a PDF
  const isPdfUrl = (url, fileType = '', extension = '') => {
    if (!url) return false;
    const ft = String(fileType || '').toLowerCase();
    const ext = String(extension || '').toLowerCase();
    return (
      url.toLowerCase().includes('.pdf') ||
      url.toLowerCase().includes('application/pdf') ||
      ft === 'application/pdf' ||
      ft === 'pdf' ||
      ext === 'pdf'
    );
  }
  const DESIGN_PREVIEW_EXTENSIONS = ['eps', 'ai', 'psd', 'tif', 'tiff', 'bmp', 'webp', 'ps', 'indd', 'indt', 'x-eps', 'x-ai', 'postscript'];
  const getFileExtensionFromUrl = (url) => {
    if (!url) return '';
    const clean = url.split('?')[0];
    return clean.includes('.') ? clean.split('.').pop().toLowerCase() : '';
  };
  const isGoogleViewerDesignUrl = (url, fileType = '', extension = '') => {
    const extFromUrl = getFileExtensionFromUrl(url);
    const ext = String(extension || '').toLowerCase();
    const ft = String(fileType || '').toLowerCase();
    const mimeSubtype = ft.includes('/') ? ft.split('/').pop() : ft;
    return (
      DESIGN_PREVIEW_EXTENSIONS.includes(extFromUrl) ||
      DESIGN_PREVIEW_EXTENSIONS.includes(ext) ||
      DESIGN_PREVIEW_EXTENSIONS.includes(mimeSubtype)
    );
  };
  const TABS = [
    {
      value: 'SUBTASKS',
      component: <SubTasks details={details} taskData={data} data={subTasks} setFetchData={setFetchData} projectMembers={projectMembers} taskId={id} projectId={projectId} setRefresh={setRefresh} refresh={refresh} currentTab={currentTab} onDataChange={onDataChange} isMirrored={isMirrored} />,
    },
  {
    value: 'POSTS',
    component: <Posts projectPosts={projectPosts} taskId={Number(id)} projectId={projectId}
      refresh={refresh} setRefresh={setRefresh} currentTab={currentTab}/>,
  },
  {
    value: 'ATTACHMENTS',
    component: <Attachments taskId={Number(id)} projectId={projectId} details={details}  
    refresh={refresh} setRefresh={setRefresh} currentTab={currentTab} taskData={data} taskAttachments={taskAttachments} mirrored={isMirrored} targetFacilityId ={details?.origin_facility_id || null}/>,
  },
  {
    value: 'SKILLS',
    component: <Activities skills={skills}/>,
  },
  // {
  //   value: 'ACTIVITIES',
  //   component: <Activities />,
  // },
  ]

  useEffect(() => {
    try {
      axios.post(`${REST_API_END_POINT}project/fetch-all-project-sub-task`,{
        taskId: Number(id),userType: hasViewAsAdminPermission ? 1 : user.user_type, userId: user.user_id,requestId:details?.request_id,isMirrored:isMirrored,targetFacilityId:details?.origin_facility_id || null,
      },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          setSubTasks(response.data.result)
          setSkills(response.data.skills)
        }
      
      }).catch((error) => {
        console.error(error);
      })
      setFetchData(false)
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }, [fetchData,isMirrored])

  useEffect(() => {
    try {
      axios.post(`${REST_API_END_POINT}project/view-project-task`,{ taskId: id, projectId,userId: user.user_id,isMirrored:isMirrored,targetFacilityId:details?.origin_facility_id || null},{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          setProjectPosts(response.data.projectPost)
          setData(response.data.result[0])
          // console.log("dataaaaaaaaaaaaaa",response);
          
          setProjectMembers(response.data.projectMembers)
         
          // Assume 'statusValue' is the value you want to filter by

       option = option.filter(opt => opt.id=== response.data.result[0].status);
       setOptions(option)
         
        }
      
      }).catch((error) => {
        console.error(error);
      })
      // handleFetchEditData(id)
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }, [isEdit,refresh,isMirrored])

  useEffect(() => {
    if(data?.status){
      setValue(option.find(opt=>opt.id === data.status))
    }
  }, [data])

  useEffect(() => {
    const isMirrored = details?.origin_facility_id != currentFacilityId && details?.project_category_id !== 15 && details?.is_split_order == 1 ? true : false;
    console.log('isMirrored', isMirrored)
    setIsMirrored(false)
  }, [details])

  const handleUpdateStatus = (status)=>{
    try {
      axios.post(`${REST_API_END_POINT}project/update-project-task-status`,{ taskId: id, status, userId: user.user_id },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          setValue(option.find(opt=>opt.id === status))
          enqueueSnackbar(response.data.message, { variant: 'success' });
        }else if(response.data.status === 0){
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
      
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }
  const handleDeleteTask = ()=>{
    try {
      // const  user  = JSON.parse(window.localStorage.getItem('user'))
      axios.post(`${REST_API_END_POINT}project/delete-project-task`,{ id: Number(id),projectId, status: 0 },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 4){
          enqueueSnackbar(response.data.message, { variant: 'success' });
         if(popupOn){
          // onDataChange()
          handleBackToAlljobs()
         }
          else{ navigate(PATH_DASHBOARD.project.viewproject+projectId)}
        }else if(response.data.status === 5){
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        setIsDelete(false)
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }

  const handleTab = (event, newValue) => {
    setSecTab(newValue)
  }


  useEffect(()=>{
    fetchAttachmentsFromTask()
  },[id,isMirrored])

  const fetchAttachmentsFromTask =async()=>{
    const response = await axios.post(`${REST_API_END_POINT}project-task/fetch-all-designs-from-task`,{id,requestId,projectId,mirrored:isMirrored,targetFacilityId:details?.origin_facility_id || null})
    if(response.data.status==1){
      setTaskAttachments(response?.data?.attachments)
    }else{
      setTaskAttachments([])
    }
  }

  return (
    <Container sx={{mt:2}}>
      {/* {loading ? 
        <LoadingScreen sx={{ top: 0, left: 0, width: 1, zIndex: 9999, position: 'fixed' }} />
      :
        <> */}
          <Stack justifyContent='space-between' flexDirection='row'>
            {popupOn?<Button
              variant="outlined"
              type="submit"
              onClick={handleBackToAlljobs}
              // component={RouterLink}
              // to={PATH_DASHBOARD.project.viewproject+projectId}
              state={{currentTab:currentTab}}
              sx={{ alignItems: 'flex-end', mb: 3.5 }}
              startIcon={ // Use the startIcon prop to add an icon to the left
                <Stack>
                  <KeyboardBackspaceOutlined/>
                </Stack>

              }
            >
              Back to Job Details
            </Button>:
            <Button
            variant="outlined"
            type="submit"
            component={RouterLink}
            to={PATH_DASHBOARD.project.viewproject+projectId}
            state={{currentTab:currentTab}}
            sx={{ alignItems: 'flex-end', mb: 3.5 }}
            startIcon={ // Use the startIcon prop to add an icon to the left
              <Stack>
                <KeyboardBackspaceOutlined/>
              </Stack>

            }
          >
            Back to Job Details
          </Button>}
          </Stack>
          <Stack spacing={5}>
            <Stack
              // direction="row"
              alignItems="center"
              justifyContent="center"
              sx={{
                background:
                  theme.palette.mode === 'light' ? theme.palette.background.paper : theme.palette.grey[800],
                borderRadius: 2,
                boxShadow: theme.palette.mode === 'light' ? `0 0 20px ${theme.palette.grey[300]}` : 'none',
              }}
            >
              <Grid container justifyContent={'center'}>
                <Grid item xs={8} pt={4}>
                  <Stack spacing={3}>
                    <Card
                      style={{
                        height: 300,
                        width: '100%',
                        position: 'relative',
                        // backgroundImage:
                        //   `url(${data?.cover_image})`,
                      }}
                    >
                      {(() => {
                        const imageUrl = (data?.product_design && data?.approved==1) 
                          ? data?.product_design 
                          : data?.avatarUrl 
                          ? data?.avatarUrl
                          : logo;
                        const mediaType = data?.file_type || data?.mime_type || '';
                        const mediaExtension = data?.extension || '';
                        const isPdf = isPdfUrl(imageUrl, mediaType, mediaExtension);
                        const isGoogleViewerDesign = isGoogleViewerDesignUrl(imageUrl, mediaType, mediaExtension);
                        
                        if (isPdf) {
                          return (
                            <Box
                              sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                              }}
                            >
                              <Tooltip title="View PDF">
                                <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setPdfLoading(true);
                                    setSelectedPDF(imageUrl);
                                    setOpenPDFModal(true);
                                    setUseOfficeViewer(true);
                                  }}
                                  aria-label="open pdf"
                                  sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 200,
                                    color: theme.palette.error.main,
                                    backgroundColor: theme.palette.text.primary,
                                  }}
                                >
                                  <PictureAsPdf style={{ fontSize: 50 }} />
                                </IconButton>
                              </Tooltip>
                              <iframe
                                src={imageUrl}
                                title={imageUrl}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                }}
                                frameBorder="0"
                              />
                            </Box>
                          );
                        }
                        if (isGoogleViewerDesign) {
                          return (
                            <Box
                              sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                zIndex: 8,
                              }}
                            >
                              <iframe
                                src={`https://docs.google.com/gview?url=${encodeURIComponent(imageUrl)}&embedded=true`}
                                title={imageUrl}
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                style={{ border: 'none' }}
                              />
                            </Box>
                          );
                        }
                        return <CoverImgStyle src={imageUrl} />;
                      })()}
                    </Card>
                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      spacing={3}
                      justifyContent={'flex-start'}
                      alignItems={'center'}
                      sx={{
                        '& .MuiTypography-root': {
                          color: theme.palette.mode === 'light' ? theme.palette.text.primary : 'inherit',
                        },
                      }}
                    >
                      {/* Section to view Name and Note  */}
                  <Box>
                    
                    <Typography>{data?.name}</Typography>
                    <Typography variant="h4" >

                      {data?.product_id && data?.product_notes && data?.product_notes !== ''  ?
                        <Tooltip title={<span style={{ whiteSpace: 'pre-line', color: "#ff0000", fontWeight: "bold" }}>
                          <span style={{ fontWeight: "bolder" }}>Note : {" "}</span>{data?.product_notes}
                        </span>}>
                          <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, color: 'error.main' }}>Note :  {"  "}{data?.product_notes?.length > 20
                            ? data.product_notes.slice(0, 20) + '...'
                            : data?.product_notes}
                          </Typography>
                        </Tooltip> : " "} 


                      {data?.service_notes && data?.service_notes !== ''  ?
                        <Tooltip title={<span style={{ whiteSpace: 'pre-line', color: "#ff0000", fontWeight: "bold" }}>
                          <span style={{ fontWeight: "bolder" }}>Note : {" "}</span>{data?.service_notes}
                        </span>}>
                          <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, color: 'error.main' }}>Note :  {"  "}{data?.service_notes?.length > 20
                            ? data.service_notes.slice(0, 20) + '...'
                            : data?.service_notes}
                          </Typography>
                        </Tooltip> : " "}

                    </Typography>
                  </Box>
                      {(data?.service_id && !data?.service_workflow) ? (
                        <Stack
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={1}
                          justifyContent={'flex-start'}
                          alignItems={'center'}
                        >
                          <Info sx={{ color: theme.palette.error.main  }} />
                          <Typography sx={{ color: theme.palette.error.main }}>
                            No service workflow has been chosen.
                          </Typography>
                        </Stack>
                      ) : ''}
                      {/* <Typography>
                        <Label
                          variant={'filled'}
                          color={value?.color || 'info'}
                        >
                          {sentenceCase(value?.value || '')}
                        </Label>
                      </Typography> */}
                      {/* <TextField
                        select
                        size="small"
                        value={value.value}
                       
                        sx={{
                          minWidth: { lg: '30%', md: '50%', sm: '40%' },
                          background: colors[value.id],
                          color:'blue',
                          borderRadius: 1,
                          border: 'none',
                          '&:hover': {
                            // transform: 'scale(1.02)',
                            border: 'none',
                          },
                        }}
                     
                      >
                        {console.log("################OPtion",option)}
                        {options.map((optio) => (
                          <MenuItem
                            // onClick={() => {
                            //   handleUpdateStatus(optio.id)
                            //   setValue(optio)
                            // }}
                            key={optio.value}
                            value={optio.value}
                          >
                            {optio.value}
                          </MenuItem>
                        ))}
                          
                      </TextField> */}
                    </Stack>
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                      <Stack direction={'row'} spacing={1}>
                        {/* <Typography variant="subtitle2">{data?.member_count} Members</Typography> */}
                        <Typography variant="subtitle2">{(data?.file_count +taskAttachments.length)} Attachments</Typography>
                      </Stack>
                      <Box sx={{mb: -2}}>
                        { (user.user_type !== 3 &&!isMirrored && currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' && currentTab!="Completed" && currentTab!="Hold" && details?.status != 3 && details?.hold != 1 && details?.status != 9) &&
                          <UserMoreMenu onDelete={()=>setIsDelete(true)} onEdit={()=>setIsEdit(true)}/>
                        }
                      </Box>
                    </Stack>
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                      <Box sx={{ display: 'flex',justifyContent:'flex-start', alignItems: 'center',}}>
                        <Stack>    
                          <Typography variant="subtitle2">
                              Job Members
                          </Typography>             
                          <AvatarGroup max={4}>
                            {projectMembers?.map((row)=>( 
                                <Tooltip key={row.id} title={row.name}>             
                              <Avatar src={row.profile_pic} alt={row.name} />
                              </Tooltip>                   
                            ))}
                          </AvatarGroup>
                        </Stack>
                      </Box>
                      {/* <Box sx={{mb: -2}}>
                        { (user.user_type !== 3 && currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' && currentTab!="Completed" && currentTab!="Hold" && details?.status != 3 && details?.hold != 1 && data?.status != 3 && subTasks?.length <= 0) && // && (data?.isAdditionalProduct == 1 || data?.service_isAdditionalProduct == 1)
                          <Button variant='contained'
                            onClick={()=>{
                              handleUpdateStatus(3);
                              handleBackToAlljobs()
                            }}>Complete</Button>
                        }
                      </Box> */}
                    </Stack>
                    <Divider />
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                    <Tabs
                      value={secTab}
                      scrollButtons="auto"
                      variant="scrollable"
                      allowScrollButtonsMobile
                      onChange={handleTab}
                    >
                      {TABS.map((tab) => (
                        <Tab
                          disableRipple
                          key={tab.value}
                          label={
                            <Typography variant="overline">
                              {capitalCase(tab.value)}
                            </Typography>
                          }
                          icon={tab.icon}
                          value={tab.value}
                        />
                      ))}
                    </Tabs>
                {data?.product_id && data?.recipe_id ? (
                  <Button
                    variant="contained"
                    sx={{ width: '270px' }}
                    type="button"
                    onClick={() => setOpenViewProductFormulaModal(true)}
                    startIcon={
                      <Stack>
                        <Visibility />
                      </Stack>
                    }
                  >
                    View Product Formula
                  </Button>
                ) : ''}
                <Button
                  variant="contained"
                  sx={{ width: '270px',marginLeft: '20px' }}
                  type="button"
                  onClick={() => setOpenQRModal(true)}
                  startIcon={
                    <Stack>
                      <QrCode2 />
                    </Stack>
                  }
                >
                  Generate QR Code
                </Button>
                </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Stack>
            <Stack sx={{ alignItems: 'center', mb: 2 }} spacing={2}>
              {TABS.map((tab) => {
                const isMatched = tab.value === secTab
                return (
                  isMatched && (
                    <Box sx={{ width: '75%' }} key={tab.value}>
                      {tab.component}
                    </Box>
                  )
                )
              })}
            </Stack>
          </Stack>
          <AddTask data={data} setData={setData} projectMembers={projectMembers} projectId={Number(data?.project_id)} add={isEdit} setAdd={setIsEdit} refresh={refresh} setRefresh={setRefresh} />
          <ConfirmationPopup open={isDelete} handleClick={handleDeleteTask} message={'Want to Delete This Task'} handleClose={()=>setIsDelete(false)}/>
          
          {/* PDF Modal Dialog */}
          <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
            <Card sx={{ padding: 3, maxWidth: 768, margin: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{width:'90%', display:'flex',justifyContent:'flex-end', marginBottom: '15px',marginLeft:'25px' }}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    if (isClient || userType === 3) {
                      // For clients/userType 3: Open PDF in new window without toolbar
                      const newWindow = window.open('', '_blank');
                      newWindow.document.write(`
                        <html>
                          <head>
                            <title>PDF Viewer</title>
                            <style>
                              body { margin: 0; padding: 0; overflow: hidden; }
                              iframe { width: 100vw; height: 100vh; border: none; }
                            </style>
                          </head>
                          <body>
                            <iframe src="${selectedPDF}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
                          </body>
                        </html>
                      `);
                      newWindow.document.close();
                    } else {
                      // For other users: Open PDF normally
                      window.open(selectedPDF, '_blank');
                    }
                  }}
                  disabled={!selectedPDF}
                  startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                  sx={{
                    fontSize:'14px'
                  }}
                >
                  View PDF
                </Button>
              </div>
              {pdfLoading && (
                <Skeleton variant="rectangular" width="100%" height={500} />
              )}

              {(isClient || userType === 3) && useOfficeViewer ? (
                <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
                  title="Selected PDF"
                  width="100%"
                  height="500px"
                  frameBorder="0"
                  style={{ display: pdfLoading ? 'none' : 'block' }}
                  onLoad={() => setPdfLoading(false)}
                  onError={() => {
                    // If Google Docs viewer fails, fallback to direct iframe
                    setUseOfficeViewer(false);
                    setPdfLoading(false);
                  }}
                />
              ) : (
                <iframe
                  src={selectedPDF}
                  title="Selected PDF"
                  width="100%"
                  height="500px"
                  frameBorder="0"
                  style={{ display: pdfLoading ? 'none' : 'block' }}
                  onLoad={() => setPdfLoading(false)}
                />
              )}
            </Card>
          </DialogAnimate>

          <ViewProductFormulaModal
          fromTask={true}
      open={openViewProductFormulaModal}
      onClose={() => setOpenViewProductFormulaModal(false)}
      formulaId={data?.recipe_id}
      selectedTab={details?.project_type_name?.toLowerCase().includes('production') ? 'production' : details?.project_type_name?.toLowerCase().includes('traffic') ? 'traffic' : 'split'}
      explodedPermissions={explodedPermissions}
      user={user}
    />

          {/* QR Code Modal */}
          <DialogAnimate open={openQRModal} onClose={() => setOpenQRModal(false)}>
            <Card sx={{ padding: 3, maxWidth: 400, margin: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Scan QR Code to View Task
              </Typography>
              <Box 
                ref={qrCodeRef}
                sx={{ 
                  padding: 2, 
                  backgroundColor: 'white', 
                  borderRadius: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <QRCode
                  value={`${BASE_URL_QR}${PATH_DASHBOARD.project.viewTaskQR.replace(':id', id).replace(':projectId', projectId)}${popupOn ? `?popupOn=true&postId=${postId || id}&projectsId=${projectsId || projectId}${taskCurrentTab || currentTab ? `&taskCurrentTab=${encodeURIComponent(taskCurrentTab || currentTab)}` : ''}${requestId ? `&requestId=${requestId}` : ''}` : ''}`}
                  size={256}
                  bgColor={'#ffffff'}
                  fgColor={'#000000'}
                  level={'M'}
                  includeMargin={true}
                />
                <Typography variant="body2" sx={{ mt: 2, textAlign: 'center', color: 'text.secondary' }}>
                  Scan this QR code to navigate to the task page
                </Typography>
              </Box>
              <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                <ReactToPrint
                  trigger={() => (
                    <Button
                      variant="contained"
                      startIcon={<PrintOutlined />}
                    >
                      Print QR Code
                    </Button>
                  )}
                  content={() => qrCodeRef.current}
                />
                <Button
                  variant="outlined"
                  onClick={() => setOpenQRModal(false)}
                >
                  Close
                </Button>
              </Stack>
            </Card>
          </DialogAnimate>
        {/* </>
      } */}
    </Container>
  )
}
